const StaffExitFlowSelectedRadioButton = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <circle cx="16" cy="16" r="15.25" stroke="#B3B3B3" strokeWidth="1.5" />
      </svg>
  );
};
export default StaffExitFlowSelectedRadioButton;
